export default {
    methods: {

    }
};